<template>
  <div>
    <div class="col-md-12 m-0 p-0 row">
      <div class="col-md-6 m-0 p-0 d-flex justify-content-between">
        <div>
          <label for="filterAgent">Type</label>
          <b-form-select v-model="filterAgent" :options="options"></b-form-select>
        </div>
        <div>
          <label for="filterLimit">Limit</label>
          <b-form-select v-model="limit" :options="limitOptions"></b-form-select>
        </div>
      </div>
      <div class="col-md-6 m-0 p-0 d-flex">
        <div class="col-md-6">
          <label for="example-datepicker">Choose Start Date</label>
          <b-form-datepicker id="example-datepicker" v-model="startDate" class="mb-2"></b-form-datepicker>
        </div>
        <div class="col-md-6">
          <label for="example-datepicker">Choose End Date</label>
          <b-form-datepicker id="example-datepicker" v-model="endDate" class="mb-2"></b-form-datepicker>
        </div>
      </div>
    </div>
    <b-table 
    hover 
    responsive 
    :busy="makingAJAX" 
    :items="knowlarity"
    :fields="dataFields"
    caption-top
    >
    <template #table-caption>Total of {{rows}} entries found.</template>
      <template #table-busy>
            <div class="text-center text-danger my-5">
            <b-spinner class="align-middle"></b-spinner>
            <p class="my-3"><strong>We are Loading...</strong></p>
            </div>
        </template>
    </b-table>
    <div>
      <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="limit"
      aria-controls="my-table"
      align="center"
    ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      items: [],
      filterAgent: 'NO_ANSWER',
      options: ['NO_ANSWER','NA','User Disconnected'],
      limitOptions: [10,20,50],
      startDate: '',
      endDate: '',
      offset: 0,
      limit: 10,
      dataFields: [
        {
          key: 'customer_number',
          sortable: false,
          label: 'Customer Phone'
        }, {
          key: 'business_call_type',
          label: 'Call Type'
        },
        {
          key: 'Call_Type',
          label: 'Type',
          formatter: (value) => {
            if(value == 0){
              return 'Incoming'
            }else{
              return 'Outgoing'
            }
          },
        },
        {
          key: 'knowlarity_number',
          label: 'Knowlarity Phone'
        },
        {
          key: 'start_time',
          label: 'Created on',
          formatter: (value) => {
            return moment(value).format('LL, h:mm a')
          },
          sortable: true
        }
      ],
      currentPage: 0
    };
  },
  created() {
    this.fetchData();
  },
  mounted(){
    this.endDate = moment().format("YYYY-MM-DD");
    this.startDate = moment().subtract(7, 'days').format("YYYY-MM-DD")
  },
  watch : {
    filterAgent () {
      this.fetchData()
    },
    startDate () {
      this.fetchData()
    },
    endDate () {
      this.fetchData()
    },
    limit () {
      this.fetchData()
    },
    currentPage () {
      this.fetchData()
    }
  },
  methods: {
    fetchData() {
      this.$store.dispatch("get_Knowlarity_data", {
        endDate: this.endDateFormatted,
        startDate: this.startDateFormatted,
        agentNumber: this.filterAgent,
        offset: (this.currentPage - 1) * this.limit,
        limit: this.limit,
      });
    },
  },
  computed: {
    // currentPage () {
    //   return this.offset/this.limit
    // },
    makingAJAX() {
      return this.$store.state.makingAJAX;
    },
    knowlarity() {
      return this.$store.state.knowlarity_data.objects || []
    },
    knowlarityCount() {
      return this.$store.state.knowlarity_data.meta || []
    },
    rows (){
      return this.knowlarityCount.total_count || 0
    },
    endDateFormatted() {
      if (this.endDate) {
        return moment(this.endDate).format("YYYY-MM-DD");
      } else {
        return moment().format("YYYY-MM-DD");
      }
    },
    startDateFormatted() {
      if (this.startDate) {
        return moment(this.startDate).format("YYYY-MM-DD");
      } else {
        return moment().format("YYYY-MM-DD");
      }
    },
  },
};
</script>
